import { MagentoProductPrices } from 'lib/types'
import { InterceptChangeEvent } from 'lib/ui/components/Form/types'

export const onlyNumbersInterceptor = (e: InterceptChangeEvent<string>) => {
  const isValid = /^\d+$/.test(e.value) || e.value === ''
  return !isValid
}

export const productHasSpecialPrice = (price: MagentoProductPrices) => {
  const { regularPrice, maximalPrice } = price
  const { amount: amountRegular } = regularPrice
  const { amount: amountMaximal } = maximalPrice
  const { value: valueRegular } = amountRegular
  const { value: valueMaximal } = amountMaximal
  return valueMaximal < valueRegular
}
